const selectQuestions = (state) => state.orderDetails.questions;
const selectShipping = (state) => state.orderDetails.shipping;
const selectContact = (state) => state.orderDetails.contact;

export {selectQuestions, selectShipping, selectContact};
